import i18n from "i18next";

import Preloader from "@krea/customer-features/shared-components/preloader";
import { Text } from "@krea/customer-features/shared-components/text";

const SMSFlow = ({ isPending, isError }) => {
  return (
    <div className="d-flex align-items-center w-100 mr-10">
      {isPending && <Preloader size="md" className="text-primary mr-2" />}

      <Text size="md" className="font-weight-bold">
        {isError && i18n.t("bankIDFlow.identificationError")}
        {isPending && i18n.t("bankIDFlow.waitingForCustomer")}
      </Text>
    </div>
  );
};

export default SMSFlow;
